
class CapEditStudentNotes {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'edit_student_notes'
}

function create(config) {
  return new CapEditStudentNotes(config)
}

export default {
  key,
  create,
}
